import styled from "styled-components";
import { Menu } from "antd";

export const MenuStyle = styled(Menu)`
  margin-top: 25px;
`;
